import {
  ConfigurationApi,
  configurationApiRef,
} from '@agilelab/plugin-wb-configuration-common';
import { useApi } from '@backstage/core-plugin-api';
import { useQuery as useReactQuery } from '@tanstack/react-query';
import { ConfigSchema } from '@agilelab/plugin-wb-platform-common';

export type HelpLinksConfig = NonNullable<
  NonNullable<ConfigSchema['fe']>['helpLinks']
>;
export type HelpLink = NonNullable<HelpLinksConfig['items']>[number];

const STALE_TIME = 1000 * 60 * 5;
export const HELP_LINKS_QUERY_KEY = ['platformHelpLinksConfig'];

const queryFn = (wbConfigApi: ConfigurationApi) => async () => {
  return (
    (await wbConfigApi.get<HelpLinksConfig>({
      namespace: 'platform',
      key: 'fe.helpLinks',
    })) ?? null
  );
};

export const useHelpLinksConfig = (noCache?: boolean) => {
  const wbConfigApi = useApi(configurationApiRef);
  const { data, isLoading, error } = useReactQuery(
    HELP_LINKS_QUERY_KEY,
    queryFn(wbConfigApi),
    {
      staleTime: noCache ? 0 : STALE_TIME,
    },
  );
  return { data, isLoading, error };
};
